import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Seo } from "../components/site/Seo";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="pt-16 min-h-[70vh] flex items-center justify-center px-5">
      <Seo title="Page Not Found | HyroxNinja" description="This page does not exist on HyroxNinja." noindex />
      <div className="text-center max-w-md">
        <p className="font-head font-black uppercase text-outline leading-none" style={{ fontSize: "clamp(5rem, 18vw, 10rem)" }} aria-hidden="true">404</p>
        <h1 className="font-head font-black uppercase tracking-tight text-3xl mb-3">Page not found</h1>
        <p className="text-zinc-400 text-sm leading-relaxed mb-7">
          That route doesn't exist. 8 runs, 8 stations — but not this one.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/" className="btn-volt" data-testid="notfound-home-link">
            <ArrowLeft size={15} /> Back Home
          </Link>
          <Link to="/events" className="btn-ghost" data-testid="notfound-events-link">
            See Events <ArrowRight size={15} />
          </Link>
        </div>
      </div>
    </div>
  );
}
